import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import {
  UpdateMaintenanceRequestScheduledDate,
  UpdateMaintenanceRequestScheduledDateVariables,
} from '../../../athena/types/UpdateMaintenanceRequestScheduledDate';

export const MUTATION = gql`
  mutation UpdateMaintenanceRequestScheduledDate(
    $maintenanceRequestId: String!
    $newScheduledDate: OdProtosCommon_DateInput!
  ) {
    webMaintenance {
      updateMaintenanceRequestScheduledDate(
        input: { maintenanceRequestId: $maintenanceRequestId, newScheduledDate: $newScheduledDate }
      ) {
        _empty
      }
    }
  }
`;

export const useUpdateMaintenanceRequestScheduledDate = () => {
  return useMutation<
    UpdateMaintenanceRequestScheduledDate,
    UpdateMaintenanceRequestScheduledDateVariables
  >(MUTATION);
};
